import { Divider, Flex, Typography } from 'antd'
import type { ReactNode } from 'react'

const { Text } = Typography

type Props = {
  title: ReactNode
  description?: ReactNode
  control: ReactNode
  last?: boolean
  /** Use a red divider colour — pass `true` inside the Danger zone card. */
  danger?: boolean
}

export const SettingRow = ({
  title,
  description,
  control,
  last,
  danger
}: Props) => {
  return (
    <>
      <Flex
        align="center"
        justify="space-between"
        gap={14}
        style={{ padding: '10px 0' }}
      >
        <Flex vertical style={{ minWidth: 0, lineHeight: 1.35, flex: 1 }}>
          <Text strong style={{ fontSize: 13 }}>
            {title}
          </Text>
          {description ? (
            <Text type="secondary" style={{ fontSize: 11.5 }}>
              {description}
            </Text>
          ) : null}
        </Flex>
        <div style={{ flex: '0 0 auto' }}>{control}</div>
      </Flex>
      {last ? null : (
        <Divider
          style={{
            margin: 0,
            ...(danger ? { borderColor: 'var(--ant-color-error-border)' } : {})
          }}
        />
      )}
    </>
  )
}
